import { createSignal, onCleanup } from 'solid-js';

const SAVED_MS = 2500;

export const createSaveConfirmation = () => {
  const [saved, setSaved] = createSignal(false);
  let timer: ReturnType<typeof setTimeout> | undefined;

  const confirmSaved = () => {
    setSaved(true);
    if (timer !== undefined) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => setSaved(false), SAVED_MS);
  };

  onCleanup(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }
  });

  return { saved, confirmSaved };
};
